<template>
  <!--导航-->
  <div ref="nav-box" class="nav">
    <ul class="nav-list" :class="{en: language == 'en' ? true : false}" :style="{'background-color':color,width: '100%'}">
      <li v-if="item.navType != 6" :style="{width: Math.floor(1008/(navs.length))+'px'}" class="nav-item"
          :class="[item.active === true ?'active':'']" @click="toPosition(`id_${item.navId}`,index)"
          v-for="(item,index) in navs" :key="index">
        <a v-if="item.navUrl" :target="item.linkTarget" :href="item.navUrl">{{item.navName}}</a>
        <span v-if="!item.navUrl">
            {{item.navName}}
          </span>
        <b class="nav-tip" v-if="item.active"></b>
        <b class="nav-tip2" v-if="index!==navs.length-1"></b>
      </li>
      <!--<li :class="[item.active? 'active': '']" v-for="(item,i) in navs" :key="i" @click="toPosition(`id_${item.navId}`,i)">-->
      <!--<span v-if="!item.navUrl">{{item.navName}}</span>-->
      <!--</li>-->
    </ul>
  </div>
</template>
<script>
  import icon from "../icon"
  function getElementTop(element) {
    let actualTop = element.offsetTop;
    let current = element.offsetParent;
    while (current !== null) {
      actualTop += current.offsetTop;
      current = current.offsetParent;
    }
    return actualTop;
  }
  //    可以滚动
  let active = true;

  export default{
    data(){
      return {
        activeNav: 0,
        language: 'ch'
      }
    },
    props: {
      iconClass: {
        type: String
      },
      author: {
        type: String,
        default: () => {
          return '登录'
        }
      },
      navs: {
        type: Array
      },
      color: {
        type: String,
        default: () => {
          return '#f39800'
        }
      }
    },
    computed: {},
    methods: {
      doActive(index){
        this.navs.map((item, i) => {
          item.active = false;
          if (i === index) {
            item.active = true;
          }
          this.$set(this.navs, i, item);
        });
        this.activeNav = index;
      },
      toPosition(_obj, index){
          this.$emit('closeSearch');
          setTimeout(()=>{
            //                如果不可以滚动的话；就返回
            if (!active) return;
            this.doActive(index);
            let targetX, targetY;
            if (!_obj) { //如果不指定锚点元素，就跳到页面顶端0，0位置
              targetX = 0;
              targetY = 0;
            } else {
              if (typeof (_obj) == "string") {
                _obj = document.getElementById(_obj);
              } else {
                _obj = _obj
              }
              targetX = _obj.getBoundingClientRect().left + this.$getScrollOffsets().x;
              targetY = _obj.getBoundingClientRect().top + this.$getScrollOffsets().y - 55;
            }

            //如果目标元素的位置在最后一屏，那就指定目标位置为页面底部
            //如果目标元素的位置为负数，就指定目标位置为页面顶部
            let maxTargetX = document.body.scrollWidth - this.$getViewPortSize().x;
            if (targetX >= maxTargetX) targetX = maxTargetX;
            if (targetX < 0) targetX = 0;
            let maxTargetY = document.body.scrollHeight - this.$getViewPortSize().y;
            if (targetY >= maxTargetY) targetY = maxTargetY;
            if (targetY < 0) targetY = 0;
            let _self = this;
            let tempTimer = setInterval(function () {
              active = false;
              let currentY = _self.$getScrollOffsets().y;
              let currentX = _self.$getScrollOffsets().x;
              //跳转位置的缓冲公式
              let tempTargetY = currentY - (currentY - targetY) / 10;
              let tempTargetX = currentX - (currentX - targetX) / 10;
              //由于缓冲公式会生成小数，而scrollTo函数会省略小数点后面的数字，所以要对跳转的坐标做一些微调
              if (Math.abs(tempTargetY - currentY) < 1) {
                tempTargetY - currentY > 0 ? tempTargetY++ : tempTargetY--;
              }
              if (Math.abs(tempTargetX - currentX) < 1) {
                tempTargetX - currentX > 0 ? tempTargetX++ : tempTargetX--;
              }
              //页面跳转
              window.scrollTo(0, tempTargetY);
              //到达指定位置后清除一下Interval
              if (Math.abs(_self.$getScrollOffsets().y - targetY) <= 2) {
                clearInterval(tempTimer);
                window.scrollTo(0, targetY);
                //console.log("done");
                active = true;
              }
            }, 10);
          },120)
      },
      login(){
        this.$emit("login");
      }
    },
    components: {
      icon
    },
    mounted(){
      let winh = window.screen.height;
      let navBox = this.$refs['nav-box']
      this.language = localStorage.getItem('locale')

      window.addEventListener('scroll', () => {
        let startTop = document.getElementById('header-img').offsetHeight;
        let docHeight = document.documentElement.clientWidth || document.body.clientHeight;
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop >= startTop) {
          navBox.setAttribute("class", "fixed nav");
          this.$emit('fixemit',true)
        } else {
          navBox.setAttribute("class", "nav");
          this.$emit('fixemit',false);
        }
      })
    }
  }
</script>
<style lang="scss" scoped>
  .nav {
    width: 1088px;
    margin: 0 auto 0;
    border-radius: 50px;
    height: 50px;
    background: #eeeeee;
    color: #fff;
    display: flex;
    /*justify-content: center;*/
    font-size: 14px;
    padding: 1px 40px 1px 40px;
    position: relative;
    z-index: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .75);
  }

  .nav-list {
    height: 100%;
    line-height: 37px;
    background: #88b5b5;
    align-items: center;
    position: relative;
    &.en{
      font-size: 12px;
      // & .nav-item.active{
      //   // font-size: 14px;
      // }
    }
  }

  .no-border {
    border: 0;
  }

  .border-right {
    border-right: 1px solid #ffffff;
  }

  .nav-list li {
    box-sizing: border-box;
    position: relative;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    line-height: 50px;
    height: 50px;
    overflow: hidden;
    transition: all ease-in-out .3s;
  }

  .nav-list li p {
    display: inline-block;
  }

  // .nav-list li.active {
  //   /*background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,.8));*/
  //   // font-size: 16px;
  // }

  .nav-tip {
    position: absolute;
    display: block;
    width: 80%;
    left: 10%;
    height: 2px;
    /*background-color: red;*/
    border-radius: 8px;
    bottom: 2px;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .nav-tip:after {
    display: block;
    content: '';
    height: 100%;
    background-color: #ffffff;
    border-radius: 4px;
  }

  .nav-list li span,
  .nav-list li a {
    padding: 0 12px;
  }

  .user-info {
    cursor: pointer;
    line-height: 50px;
    margin-left: 10px;
    text-align: center;
  }

  .fixed {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    z-index: 600;
  }

  a {
    color: #fff;
  }

  a:hover {
    color: #78655e;
  }

  .nav-list li.active {
    color: #ffffff;
    line-height: 40px;
  }

  .nav-tip2 {
    position: absolute;
    right: 0;
    height: 20px;
    width: 1px;
    background-color: #ffffff;
    display: block;
    top: 16px;
  }
</style>



// WEBPACK FOOTER //
// iNav.vue?135e01b8